import { render, staticRenderFns } from "./WebDownloadComponent.vue?vue&type=template&id=6cb1bfdc&scoped=true&"
import script from "./WebDownloadComponent.vue?vue&type=script&lang=js&"
export * from "./WebDownloadComponent.vue?vue&type=script&lang=js&"
import style0 from "./WebDownloadComponent.vue?vue&type=style&index=0&lang=less&"
import style1 from "./WebDownloadComponent.vue?vue&type=style&index=1&id=6cb1bfdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb1bfdc",
  null
  
)

export default component.exports